import { Component, OnInit, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

import { AuthenticationService } from '../../_services/auth/authentication.service';
import { AuthService } from 'angularx-social-login';
import { NavbarService } from '../../_services/site-navbar/navbar.service';
import { User } from '../../_models/user';
import { FlexLayoutModule } from '@angular/flex-layout';
/* Dialog class */

import { GoogleAnalyticsService } from '../../_services/analytics/google-analytics.service';
import { MatListModule } from '@angular/material/list';
import {
  MatBottomSheet,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
@Component({
  selector: 'app-site-nav',
  templateUrl: './site-nav.component.html',
  styleUrls: ['./site-nav.component.scss'],
})
export class SiteNavComponent implements OnInit {
  @ViewChild(MatMenuTrigger) trainingMenu!: MatMenuTrigger;
  isLoggedIn : Observable<User>;
  constructor(private _bottomSheet: MatBottomSheet, private customAuthService: AuthenticationService,private _snackBar: MatSnackBar,private googleAnalyticsService:GoogleAnalyticsService) {
    this.isLoggedIn = this.customAuthService.isLoggedIn();
    this.isLoggedIn.subscribe(res => {
      if(res && res.firstName){
        // this.firstName = res.firstName;
      }
    });
  }

  logout(): void {
    try{
      this.customAuthService.logout();
      // this.socialAuthService.signOut();
      this._snackBar.open("You're Logged out successfully.", 'Dismiss', { duration: 5000 });
    }catch(err){
      this.googleAnalyticsService.exceptionEmitter('logout',err,false);
    }
  }


  ngOnInit() {}

  openBottomSheet(): void {
    this._bottomSheet.open(SiteNavInnerComponent, {
      panelClass: 'my-height',
      closeOnNavigation: true,
    });
  }

  hideMenu(menu: MatMenuTrigger) {
    menu.closeMenu();
  }
  
}


@Component({
  selector: 'bottom-sheet-overview-example-sheet',
  templateUrl: 'site-nav-inner.component.html',
})
export class SiteNavInnerComponent {
  constructor(
    private _bottomSheetRef: MatBottomSheetRef<SiteNavInnerComponent>
  ) {}

  openLink(event: MouseEvent): void {
    this._bottomSheetRef.dismiss();
    event.preventDefault();
  }

  hideNav(navbar: any) {
    navbar.classList.add('hide');
  }
}
